import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';

import { requestCreatePoll, requestUpdatePoll, requestViewPollResults } from './poll.actions';
import { getCreatePollRequest, getUpdatePollRequest, getViewPollResultsRequest } from './poll.endpoints';
import { CREATING_POLL, UPDATING_POLL, RETRIEVING_POLL_RESULTS } from './poll.constants';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setPollResults } from '../../slices/programme/tribe/tribe.slice';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performCreatePollRequest({ payload }) {
  const { input, onSuccess } = payload;

  try {
    yield put(addSpinner(CREATING_POLL));

    const [endpoint, options] = getCreatePollRequest(input);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(removeSpinner(CREATING_POLL));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner(CREATING_POLL));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForCreatePollRequest() {
  yield takeLatest(requestCreatePoll.type, performCreatePollRequest);
}

export function* performUpdatePollRequest({ payload }) {
  const { input, onSuccess } = payload;

  try {
    yield put(addSpinner(UPDATING_POLL));

    const [endpoint, options] = getUpdatePollRequest(input);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(removeSpinner(UPDATING_POLL));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner(UPDATING_POLL));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForUpdatePollRequest() {
  yield takeLatest(requestUpdatePoll.type, performUpdatePollRequest);
}

export function* performViewPollResultsRequest({ payload }) {
  const { programmeExternalReference, pollExternalReference, onSuccess } = payload;

  try {
    yield put(addSpinner(RETRIEVING_POLL_RESULTS));

    const request = getViewPollResultsRequest(programmeExternalReference, pollExternalReference);

    const { data } = yield call(axios, ...request);

    delete data.message;
    data.results.sort((resultOne, resultTwo) => {
      const votes = resultTwo.votes - resultOne.votes;
      if (votes === 0) {
        if (resultTwo.option > resultOne.option) return -1;
        if (resultTwo.option < resultOne.option) return 1;
        return 0;
      }

      return votes;
    });

    yield put(setPollResults(data));
    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(RETRIEVING_POLL_RESULTS));
  }
}

export function* watchForViewPollResultsRequest() {
  yield takeLatest(requestViewPollResults.type, performViewPollResultsRequest);
}

export default function* pollSaga() {
  yield all([watchForCreatePollRequest(), watchForUpdatePollRequest(), watchForViewPollResultsRequest()]);
}
